import {fetchAndDeserialize, serializeToURLParameters} from '../../../util/api-adapter';
import {PaginationDataType} from '../../../util/pagination-hook/pagination-hook-type';
import {objectToUrlParameters} from '../../../util/url';
import {PaginatedResponseType} from '../../api/api-type';

import {
    ReviewCityListQueryType,
    reviewCityListResponse,
    ReviewCityType,
    reviewCompetitorCityListResponse,
    ReviewCompetitorCityType,
} from './review-cities-type';

export async function fetchReviewCityList(
    options: ReviewCityListQueryType & PaginationDataType,
    mainFilterKey: string,
    sortDirection?: string
): Promise<PaginatedResponseType<ReviewCityType>> {
    const searchParameters = objectToUrlParameters({
        ...serializeToURLParameters<ReviewCityListQueryType>(options),
        filter_key: mainFilterKey,
        sort: [sortDirection],
    });

    const url = `/v2/reviews-analytics/stats/cities/?${searchParameters}`;

    return fetchAndDeserialize<PaginatedResponseType<ReviewCityType>>(url, reviewCityListResponse);
}

function getCompetitorCitiesUrl(options: ReviewCityListQueryType & PaginationDataType, mainFilterKey: string): string {
    return `/v2/reviews-analytics/stats/cities-competitors/?${objectToUrlParameters({
        ...serializeToURLParameters(options),
        filter_key: mainFilterKey,
    })}`;
}

export async function getCompetitorCities(
    options: ReviewCityListQueryType & PaginationDataType,
    mainFilterKey: string
): Promise<PaginatedResponseType<ReviewCompetitorCityType>> {
    return fetchAndDeserialize(getCompetitorCitiesUrl(options, mainFilterKey), reviewCompetitorCityListResponse);
}
